import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { TWorkflowStatus } from 'clickNgo/entities/partner/models'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { PartnerServiceOptions } from '../configs'

export interface IDeleteLegalEditPartnerRequest {
  entryId502: number
  legalWorkflowStatus: TWorkflowStatus
}

export const deleteLegalEditPartnerRequest = ({
  entryId502,
  legalWorkflowStatus,
}: IDeleteLegalEditPartnerRequest): Promise<boolean> => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'delete-edit-partner-request')
  const keyField = 'EntryId'

  const isDone = legalWorkflowStatus === PartnerWorkflowStatus.DONE
  const isRejected = legalWorkflowStatus === PartnerWorkflowStatus.REJECTED

  if (isRejected || isDone) {
    return source
      .update(PartnerServiceOptions.LEGAL_PARTNER, [{ EntryId: entryId502 }])
      .then(() => {
        return true
      })
      .catch((err: string) => {
        Logger.error(err)
        return false
      })
  }

  if (source.fetcher.delete) {
    return source.fetcher
      .delete(PartnerServiceOptions.LEGAL_PARTNER, entryId502, keyField)
      .catch((err: string) => {
        Logger.error(err)
        return false
      })
  }

  return Promise.resolve(false)
}
